import React from 'react';

import Logo from 'assets/svg/icon_b.svg';

import classes from './LoginPageLogo.module.scss';

function LoginPageLogo() {
  return (
    <img src={Logo} className={classes.icon} width="54" height="58" alt="" />
  );
}

export default LoginPageLogo;
